/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".select-box[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{width:auto;min-width:0}"];
export { styles as styles };
